import React, { useEffect, useState, Fragment } from 'react'
import { withApollo } from 'react-apollo'
import withSharedSnackbar from '../../HOCs/withSharedSnackbar'
import gql from 'graphql-tag'
import {
  Grid,
  Button,
  withStyles,
  CircularProgress,
  Typography
} from '@material-ui/core'
import { DatePicker, InlineDatePicker } from 'material-ui-pickers'
import Select from 'react-select'
import moment from 'moment'
import { YEARS, MONTHS } from './ConstantData'
import { getVariableValues } from 'graphql/execution/values'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader'

const styles = theme => ({
  root: {
    margin: '1rem 1rem'
  },
  selectStyle: {
    maxWidth: 200,
    zIndex: 150
  },
  footerStyle: {
    fontSize: '1rem'
  }
})

const GET_DAILY_PACKETS_DATA = gql`
  query($date: String!) {
    packetsCountData: getMasterPacketCountByDate(date: $date) {
      date
      totalMasterPacketCount
      data {
        server
        dayMasterPacketCount
        deviceCount
      }
    }
  }
`

const GET_MONTHLY_PACKETS_DATA = gql`
  query($month: String!) {
    packetsCountData: getMasterPacketCountByMonth(month: $month) {
      month
      totalMasterPacketCount
      data {
        server
        monthMasterPacketCount
        deviceCount
      }
    }
  }
`

const FREQUENCY = [
  {
    label: 'Day',
    value: 1
  },
  {
    label: 'Month',
    value: 2
  }
]

function HereMapsDashboard(props) {
  const { classes } = props
  const [packetsData, setPacketsData] = useState(null)
  const [packetTableData, setPacketTableData] = useState([])
  const [frequency, setFrequency] = useState(null)
  const [dayInput, setDayInput] = useState(new Date())
  const [monthInput, setMonthInput] = useState()
  const [yearInput, setYearInput] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const column = ['Server Name', 'Device Count', 'Total Packets']
  const options = {
    print: false,
    checkbox: false,
    rowHover: false,
    selectableRows: false,
    selectableRowsHeader: false
  }

  const getQueryAndVariables = () => {
    let query = null
    let variable = {}
    if (frequency.value === 1) {
      query = GET_DAILY_PACKETS_DATA
      variable = { date: moment(dayInput).format('DD/MM/YYYY') }
    } else if (frequency.value === 2) {
      query = GET_MONTHLY_PACKETS_DATA
      variable = { month: monthInput.value + '/' + yearInput.label }
    }
    return { query, variable }
  }

  const mapPacketData = packetData => {
    const { data } = packetData
    const mappedData = data.reduce((acc, item) => {
      const temp = []
      item.server ? temp.push(item.server) : temp.push('N/A')
      item.deviceCount
        ? temp.push(item.deviceCount.toLocaleString('en-US'))
        : temp.push(0)
      if (packetData.date) {
        item.dayMasterPacketCount
          ? temp.push(item.dayMasterPacketCount.toLocaleString('en-US'))
          : temp.push(0)
      }
      if (packetData.month) {
        item.monthMasterPacketCount
          ? temp.push(item.monthMasterPacketCount.toLocaleString('en-US'))
          : temp.push(0)
      }

      acc.push(temp)
      return acc
    }, [])
    console.log('mapp data', mappedData)
    setPacketTableData(mappedData)
  }

  const getPacketsData = async () => {
    const { query, variable } = getQueryAndVariables()
    const response = await props.client
      .query({
        query: query,
        variables: variable,
        fetchPolicy: 'network-only'
      })
      .catch(err => {
        console.log(err)
        props.openSnackbar('Data not available')
      })
    if (response && response.loading) return <p> Loading... </p>

    if (response) {
      if (response.data) {
        const { packetsCountData } = response.data
        console.log(packetsCountData)
        setIsLoading(response.loading)
        setPacketsData(packetsCountData)
        mapPacketData(packetsCountData)
      }
    }
  }

  const handleChange = option => {
    setFrequency(option)
    setMonthInput(null)
    setYearInput(null)
    setDayInput()
  }

  const handleClick = () => {
    setIsLoading(true)
    if (frequency) {
      getPacketsData()
    } else {
      props.openSnackbar('Choose Frequency')
    }
  }

  useState(() => {
    if (frequency) {
      getPacketsData()
    }
  }, [])

  return (
    <div className={classes.root}>
      <Grid container spacing={16}>
        <Grid item container md={12} spacing={16}>
          <Grid item md={2}>
            <Select
              options={FREQUENCY}
              name="frequency"
              value={frequency}
              onChange={handleChange}
              className={classes.selectStyle}
            />
          </Grid>
          {frequency ? (
            frequency.value === 1 ? (
              <Grid item md={2}>
                <DatePicker
                  value={dayInput}
                  onChange={setDayInput}
                  format="DD/MM/YYYY"
                />
              </Grid>
            ) : (
              <Grid item container md={4}>
                <Grid item md={6}>
                  <Select
                    options={MONTHS}
                    name="month"
                    value={monthInput}
                    onChange={setMonthInput}
                    className={classes.selectStyle}
                  />
                </Grid>
                <Grid item md={6}>
                  <Select
                    options={YEARS}
                    name="year"
                    value={yearInput}
                    onChange={setYearInput}
                    className={classes.selectStyle}
                  />
                </Grid>
              </Grid>
            )
          ) : null}
          <Grid item md={2}>
            <Button variant="contained" color="primary" onClick={handleClick}>
              {' '}
              Get Data
            </Button>
          </Grid>
        </Grid>
        {!isLoading ? (
          <Fragment>
            <Grid item md={12}>
              <MUIDataTable
                title="Packets Usage Table"
                options={options}
                columns={column}
                data={packetTableData}
              />
            </Grid>
            <Grid item container md={12} justify="flex-end">
              <Grid item md={3}>
                <Typography variant="h3" component="h4">
                  Date :{' '}
                  {packetsData
                    ? packetsData.date
                      ? packetsData.date
                      : packetsData.month
                    : ''}
                </Typography>
              </Grid>
              <Grid item md={3}>
                <Typography variant="h3" component="h4">
                  Total Packets Count :{' '}
                  {packetsData
                    ? packetsData.totalMasterPacketCount.toLocaleString('en-US')
                    : 0}
                </Typography>
              </Grid>
            </Grid>
          </Fragment>
        ) : (
          <CircularProgress color="secondary" />
        )}
      </Grid>
    </div>
  )
}

export default withStyles(styles)(
  withSharedSnackbar(withApollo(HereMapsDashboard))
)



// WEBPACK FOOTER //
// ./src/components/Pages/HereMapsDashboard/HereMapsDashboard.jsx